module.exports = __webpack_public_path__ + "img/warabee3.4ab7c61f.jpg";